import { render, staticRenderFns } from "./SessionChatRow.vue?vue&type=template&id=5f43d07f&scoped=true&"
import script from "./SessionChatRow.vue?vue&type=script&lang=js&"
export * from "./SessionChatRow.vue?vue&type=script&lang=js&"
import style0 from "./SessionChatRow.vue?vue&type=style&index=0&id=5f43d07f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f43d07f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBadge,VListItem,VListItemContent,VListItemSubtitle})
